import env from '../env.json';

let module = angular.module('app.config', [])
	.constant('config', {
		api: env.api,
		s3: 'https://s3-eu-west-1.amazonaws.com/media-count3r/'
	})
	.constant('api', env.api)
	.constant('$ionicLoadingConfig', {
		noBackdrop: true,
		template: "<ion-spinner></ion-spinner>"
	})
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/app.config.js